(() => {
  if (customElements.get('ae-product-description')) return;
  class ProductDescription extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.content = this.querySelector('.ae-description__content');
      this.button = this.querySelector('.ae-description__more');
      if (!this.content || !this.button) return;
      this.initialized = true;
      this.blocks = Array.from(this.content.children);
      this.expanded = false;
      this.onClick = () => { this.expanded = !this.expanded; this.update(); };
      this.onResize = () => { cancelAnimationFrame(this.frame); this.frame = requestAnimationFrame(() => this.update()); };
      this.button.addEventListener('click', this.onClick);
      window.addEventListener('resize', this.onResize, { passive: true });
      this.observer = new ResizeObserver(this.onResize);
      this.observer.observe(this);
      this.update();
      document.fonts?.ready.then(() => { if (this.isConnected) this.update(); });
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      window.removeEventListener('resize', this.onResize);
      cancelAnimationFrame(this.frame);
      this.observer?.disconnect();
      this.initialized = false;
    }
    update() {
      const desktop = window.matchMedia('(min-width: 990px)').matches;
      const accordion = this.closest('.ae-description-accordion')?.querySelector('details');
      if (accordion && this.desktop !== desktop) accordion.open = desktop;
      this.desktop = desktop;
      this.content.hidden = false;
      if (this.excerpt) this.excerpt.hidden = true;
      this.blocks.forEach(block => {
        block.removeAttribute('data-ae-description-hidden');
        block.classList.remove('ae-description__last-visible');
      });
      this.button.hidden = true;
      const threshold = Number(this.closest('[data-ae-collapse-threshold]')?.dataset.aeCollapseThreshold) || 750;
      if (!desktop || this.content.getBoundingClientRect().height <= threshold) return;
      const top = this.content.getBoundingClientRect().top;
      let visible = 0;
      for (const [index, block] of this.blocks.entries()) {
        if (block.getBoundingClientRect().bottom - top <= 420 || visible < 2) visible = index + 1;
        else break;
      }
      const useExcerpt = visible === this.blocks.length || visible === 0 || this.blocks[visible - 1].getBoundingClientRect().bottom - top > 600;
      this.button.hidden = false;
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.button.querySelector('span').textContent = this.expanded ? this.button.dataset.readLess : this.button.dataset.readMore;
      if (this.expanded) return;
      if (useExcerpt) {
        if (!this.excerpt) {
          this.excerpt = document.createElement('div');
          this.excerpt.className = 'rte ae-description__excerpt';
          const text = this.content.textContent.replace(/\s+/g, ' ').trim();
          const preview = text.slice(0, 400);
          this.excerpt.textContent = preview.slice(0, Math.max(preview.lastIndexOf(' '), 300)).trim() + '…';
          this.content.before(this.excerpt);
        }
        this.excerpt.hidden = false;
        this.content.hidden = true;
      } else {
        this.blocks[visible - 1].classList.add('ae-description__last-visible');
        this.blocks.slice(visible).forEach(block => block.setAttribute('data-ae-description-hidden', ''));
      }
    }
  }
  customElements.define('ae-product-description', ProductDescription);
})();
